import * as React from 'react';

import { useApplicationContext } from '../../utils/applicationContext';
import { COMPARE_ENABLED_CONFIG } from './constants/compare';
import { CompareButtonOnboarding } from './CompareButtonOnboarding';
import { CompareButtonWithTooltip } from './CompareButtonWithTooltip';
import { useCompareOnboarding } from './hooks/useCompareOnboarding';
import { trackAddNewbuildingToComparison, trackRemoveNewbuildingFromComparison } from './tracking';

interface ICompareButtonProps {
  newbuildingId: number;
  gaLabel: string;
  withOnboarding?: boolean;
}

export const CompareButton: React.FC<ICompareButtonProps> = ({ newbuildingId, gaLabel, withOnboarding = false }) => {
  const { config } = useApplicationContext();
  const [isAdded, setIsAdded] = React.useState(false);
  const isCompareEnabled = config.get<boolean>(COMPARE_ENABLED_CONFIG) || false;

  const { open, closeHandler } = useCompareOnboarding(withOnboarding && isCompareEnabled);

  const handleClick = React.useCallback(() => {
    const nextValue = !isAdded;

    setIsAdded(nextValue);

    if (nextValue) {
      trackAddNewbuildingToComparison(newbuildingId, gaLabel);
    } else {
      trackRemoveNewbuildingFromComparison(newbuildingId, gaLabel);
    }
  }, [isAdded, newbuildingId, gaLabel]);

  if (!isCompareEnabled) {
    return null;
  }

  if (!withOnboarding || !open) {
    return <CompareButtonWithTooltip isAdded={isAdded} onClick={handleClick} />;
  }

  return (
    <CompareButtonOnboarding open={open} onClose={closeHandler}>
      <CompareButtonWithTooltip disabled={true} isAdded={isAdded} onClick={handleClick} />
    </CompareButtonOnboarding>
  );
};
